import { Component } from '@angular/core';

@Component({
  selector: 'app-sales-product-analysis',
  standalone: false,
  
  templateUrl: './sales-product-analysis.component.html',
  styles: ``
})
export class SalesProductAnalysisComponent {

}
